export type IGetFieldRealValue = (
  inputs: JQuery<HTMLInputElement> | false,
  fieldId: string,
  fieldSuffix?: string,
  returnAsDate?: boolean,
  returnProtocol?: string
) => any | null;

export function getFieldRealValue(
  inputs: JQuery<HTMLInputElement> | false,
  fieldId: string,
  fieldSuffix = '',
  returnAsDate = false,
  returnProtocol?: string
): any | null {
  if (inputs && inputs.length > 0) {
    if (inputs.length > 1) {
      const dateParts = {
        day: null as any,
        hour: null as any,
        minute: null as any,
        month: null as any,
        year: null as any,
      };
      let hasDateParts = false;
      const values: string[] = [];
      let hasProtocolParts = false;

      $(inputs).each((_, elm) => {
        const ele = $(elm);
        const eleName = $(ele).attr('name') as string;
        const eleValue = $(ele).val() as string;

        if (ele.is(':checkbox') || ele.is(':radio')) {
          if (ele.is(':checked')) {
            values.push(eleValue);
          }
        } else {
          if (eleName.endsWith('_year')) {
            hasDateParts = true;
            dateParts.year = ele.val();
          } else if (eleName.endsWith('_month')) {
            hasDateParts = true;
            dateParts.month = ele.val();
          } else if (eleName.endsWith('_day')) {
            hasDateParts = true;
            dateParts.day = ele.val();
          } else if (eleName.endsWith('_hour')) {
            hasDateParts = true;
            dateParts.hour = ele.val();
          } else if (eleName.endsWith('_minute')) {
            hasDateParts = true;
            dateParts.minute = ele.val();
          } else if (eleName.endsWith('_protocol')) {
            if (returnProtocol) {
              values.push(eleValue);
            }
          } else {
            values.push(eleValue);
          }
          if (eleName.endsWith('_protocol')) {
            hasProtocolParts = true;
          }
        }
      });
      if (hasDateParts) {
        if (returnAsDate) {
          const d = new Date();
          if (dateParts.year !== null) {
            d.setFullYear(dateParts.year);
          }
          if (dateParts.month !== null) {
            d.setMonth(dateParts.month);
          }
          if (dateParts.day !== null) {
            d.setDate(dateParts.day);
          }
          if (dateParts.hour !== null) {
            d.setHours(dateParts.hour);
          }
          if (dateParts.minute !== null) {
            d.setMinutes(dateParts.minute);
          }
          return d;
        }
        if (dateParts.year !== null) {
          values.push(dateParts.year);
        }
        if (dateParts.month !== null) {
          values.push(dateParts.month);
        }
        if (dateParts.day !== null) {
          values.push(dateParts.day);
        }
        if (dateParts.hour !== null) {
          values.push(dateParts.hour);
        }
        if (dateParts.minute !== null) {
          values.push(dateParts.minute);
        }
      } else if (hasProtocolParts) {
        let value = '';
        $.each(values, (_, v) => {
          value += v;
        });
        return value;
      }
      return values;
    }
    const field = window.DexeroCoreApp.getFieldProperties(fieldId, fieldSuffix);
    if (inputs.is(':checkbox') || inputs.is(':radio')) {
      if (inputs.is(':checked')) {
        return inputs.val();
      }
    } else if (inputs.attr('data-date-format') && inputs.attr('data-date-format') !== '') {
      // Field is empty
      if (!inputs.val()) {
        return '';
      }
      return inputs.data('datepicker').getMomentOfValue().format('YYYYMMDDHHmmss');
    } else if (inputs.attr('date_format') && inputs.attr('date_format') !== '') {
      let dateValue = inputs.val() as string;
      if (returnAsDate) {
        if (inputs.attr('time_format') && inputs.attr('time_format') !== '') {
          const d = window.DexeroCoreApp.parseDate(
            inputs.attr('date_format') as string,
            dateValue.substring(0, dateValue.lastIndexOf(' '))
          );
          if (d) {
            d.setHours(
              Number(
                window.DexeroCoreApp.formatTime(
                  'hh',
                  window.DexeroCoreApp.parseTime(
                    inputs.attr('time_format') as string,
                    dateValue.substring(dateValue.lastIndexOf(' ') + 1)
                  ),
                  false
                )
              )
            );
            d.setMinutes(
              Number(
                window.DexeroCoreApp.formatTime(
                  'min',
                  window.DexeroCoreApp.parseTime(
                    inputs.attr('time_format') as string,
                    dateValue.substring(dateValue.lastIndexOf(' ') + 1)
                  ),
                  false
                )
              )
            );
          }
          if (window.debug) {
            console.info(d);
          }
          return d;
        }
        return window.DexeroCoreApp.parseDate(inputs.attr('date_format') as string, dateValue);
      }
      if (inputs.attr('time_format') && inputs.attr('time_format') !== '') {
        const timeValue = window.DexeroCoreApp.formatTime(
          'hhmin',
          window.DexeroCoreApp.parseTime(
            inputs.attr('time_format') as string,
            dateValue.substring(dateValue.lastIndexOf(' ') + 1)
          ),
          false
        );
        dateValue = window
          .moment(
            window.DexeroCoreApp.parseDate(
              inputs.attr('date_format') as string,
              dateValue.substring(0, dateValue.lastIndexOf(' '))
            )
          )
          .format('YYYYMMDD');
        dateValue += timeValue;
      } else {
        dateValue = window
          .moment(window.DexeroCoreApp.parseDate(inputs.attr('date_format') as string, dateValue))
          .format('YYYYMMDD');
      }
      return dateValue;
    } else if (field && field.type === 1 && field.displayType === 4) {
      return (inputs.val() as string).split(',');
    } else {
      return inputs.val();
    }
  } else {
    let val = null;
    try {
      val = window.DexeroCoreApp.findDataEntryStoreValues(
        fieldId,
        `previousValues${fieldSuffix}`,
        fieldSuffix,
        returnAsDate
      );
    } catch (e) {
      if (window.debug) {
        console.info(e);
      }
    }
    if (val === null) {
      try {
        val = window.DexeroCoreApp.findDataEntryStoreValues(
          fieldId,
          `parentValues${fieldSuffix}`,
          fieldSuffix,
          returnAsDate
        );
      } catch (e) {
        if (window.debug) {
          console.info(e);
        }
      }
    }
    return val;
  }
  return null;
}
